<template>
  <div class="widget_input_wrapper">
    <h1>{{ title }}</h1>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "widget_input_wrapper",
  props: {
    title: {
      type: String,
      default: "Input name",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "~@/scss/constant_valiable.scss";
.widget_input_wrapper {
  width: 100%;
  margin-bottom: 15px;
  h1 {
    margin-bottom: 10px;
    color: #5a7184;
    font-weight: 500;
    font-size: 16px;
  }
}
</style>
